// extracted by mini-css-extract-plugin
export var tosLink = "_ac-0";